import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconBack: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;

  return (
    //dummy comment
    <Icon {...props}>
      <circle cx="12" cy="12" r="12" fill="#F2F2F3" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5437 11H9.85625L12.45 8.51876C12.8219 8.12814 12.8219 7.49689 12.45 7.10626C12.0781 6.71564 11.475 6.71564 11.1 7.10626L6.78125 11.2938C6.59375 11.475 6.5 11.7219 6.5 11.9938V12.0063C6.5 12.2781 6.59375 12.525 6.78125 12.7063L11.0969 16.8938C11.4719 17.2844 12.075 17.2844 12.4469 16.8938C12.8187 16.5031 12.8187 15.8719 12.4469 15.4813L9.85312 13H16.5406C17.0687 13 17.4969 12.5531 17.4969 12C17.5 11.4375 17.0719 11 16.5437 11V11Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconBack;
